import { render, staticRenderFns } from "./CourseDetailLight.vue?vue&type=template&id=3a22f114&scoped=true"
import script from "./CourseDetailLight.vue?vue&type=script&lang=js"
export * from "./CourseDetailLight.vue?vue&type=script&lang=js"
import style0 from "./CourseDetailLight.vue?vue&type=style&index=0&id=3a22f114&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.10.0_vue-template-compiler@2.7.16_webpack@5.90.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a22f114",
  null
  
)

export default component.exports